import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Grid, Typography } from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { GlobalClassKeys } from 'assets/jss/common-styles';
import BoxDrawer from 'components/BoxDrawer';
import { GridEx } from 'components/MuiExtras/Grid/GridEx';
import MuiLink from 'components/MuiExtras/MuiLink';
import MuiPaper from 'components/MuiExtras/MuiPaper';
import PublicationTypeName from 'components/Translations/PublicationTypeName';
import { PublicationType } from 'models/ApiEnums';
import { SearchPublicationDto, SearchPublicationsExcludeOptions } from 'models/ApiModels';
import * as React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { SelectPublications } from 'views/Publication/Components/SelectPublications';

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

export type PublicationSelectionResult = {
    publication: SearchPublicationDto;
    comment: string;
    createContent?: PublicationType;
};


interface IState {
    canSave: boolean;
    comment: string;
    publication: SearchPublicationDto;
    newListOpened: boolean;
}

interface IProps {
    title?: string;
    excludeOptions?: SearchPublicationsExcludeOptions;
    createPublications?: PublicationType[];
    onSelect: (item: PublicationSelectionResult) => boolean;
    onClose: () => void;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////////////////////////////

class PublicationSelectionDrawer extends React.PureComponent<Props, IState> {

    constructor(props: Props) {
        super(props);
        this.state = {
            canSave: false,
            publication: null,
            comment: null,
            newListOpened: false
        };
    }

    private returnSelection(item: PublicationSelectionResult) {
        const { onClose, onSelect } = this.props;

        if (onSelect(item)) {
            // Continua editando
            this.setState({
                canSave: false,
                publication: null,
                comment: null,
                newListOpened: false
            });
        }
        else {
            onClose();
        }
    }

    private creationPublication() {
        const { createPublications } = this.props;
        if (createPublications == null || createPublications.length == 0) return null;

        return (
            <Grid item>
                <Accordion
                    expanded={this.state.newListOpened}
                    elevation={0}
                    className={GlobalClassKeys.mutedBackground}
                    onChange={
                        (e, expanded) => {
                            this.setState({ newListOpened: expanded });
                        }
                    }
                >
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography variant="button">{this.props.t("Views.Publication.Dialogs.PublicationSelection.SummaryText")}</Typography>
                    </AccordionSummary>

                    <AccordionDetails>
                        <Grid container xs direction="column" spacing={2}>
                            {
                                createPublications.map((v) =>
                                    <Grid item>
                                        <MuiLink color="secondary" onClick={() => this.returnSelection({ publication: null, comment: null, createContent: v })}>
                                            <PublicationTypeName publicationType={v} />
                                        </MuiLink>
                                    </Grid>
                                )
                            }
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </Grid>
        );
    }

    public render() {
        const { title, onClose } = this.props;
        const { newListOpened } = this.state;
        return (
            <BoxDrawer
                open
                onClose={() => onClose()}
                title={title || this.props.t("Views.Publication.Dialogs.PublicationSelection.Title")}
            >
                <MuiPaper dense fullHeight elevation={0}>

                    <GridEx container direction="column" fullHeight wrap="nowrap">

                        <GridEx item overflow={this.state.publication ? null : "auto"} >
                            {
                                !newListOpened &&
                                <SelectPublications
                                    autoFocus
                                    options={this.props.excludeOptions}
                                    onSelect={
                                        (item) => {
                                            this.returnSelection({ publication: item, comment: null, createContent: null });
                                        }
                                    }
                                />
                            }
                        </GridEx>

                        {this.creationPublication()}

                    </GridEx>

                </MuiPaper>
            </BoxDrawer>
        );
    }
}

export default withTranslation()(PublicationSelectionDrawer);